// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"de97729b","498":"3e7e287f","703":"d8d79cdf","787":"04afbff7"}[chunkId] + ".chunk.js";
};